const B_1 = [
    {
        title: '委托合同列表',
        path: '/manage/business/zbwtht/list'
    }
]

export default {
    path: 'zbwtht',
    component: () => import(/*webpackChunkName: 'manage-business-xgsq'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'manage-business-xgsq'*/'@views/manage/views/business/wei-tuo-he-tong/list'),
            meta: {
                title: '委托合同列表',
                bread: B_1,
                topNav: true
            },
        },
    ]
}
